<template>
 <div class="progress progress-lg" style="width:100%;">
          <div class="progress-bar bg-warning" role="progressbar" :style="{ width: progressPercentage + '%' }" :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100">{{progressPercentage}}% completed</div>
 </div>
</template>
<script>
export default {
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    totalSteps: {
      type: Number,
      default: 6
    }
  },
  computed: {
    progressPercentage() {
      var percentage=(this.currentStep / this.totalSteps) * 100;
      return percentage.toFixed(2);
    }
  }
}
</script>

